import React from 'react'
import { isMobile } from 'react-device-detect'
import { Link } from 'react-router-dom'
import ProfileSection from 'app/common/pixel-menu/_comp/ProfileSection'
import moment from 'moment'
import {
  $DCDangerColor,
  $DCDangerLightColor,
  $DCInfoColor,
  $DCInfoLightColor,
  $DCSuccessColor,
  $DCSuccessLightColor,
  DcBreadcrumbs,
  DcButton,
  DcFlexBox,
  DcTag,
  PixelCurrency,
  PixelDate,
  PixelDiv,
  PixelFactoryContext,
  PixelFlexBox,
  PixelPageContainer,
  PixelTable,
  PixelTableAction,
  PixelText,
  Section,
  SectionContent,
  SectionTitle,
} from 'pixel-base'
import { AjaxResponse } from 'rxjs-compat'
import { env } from 'shared/env'
import { get } from 'utils/api-routes.util'
import PrintIcon from 'utils/icons/print-icon'

import BillingPaymentMethod from '././component/BillingPaymentMethod'
import { IPixelFactory } from '../../../../../../decl'

const columns = [
  {
    dataKey: 'id',
    name: 'Invoice #',
    sortable: true,
    selector: (row) => row.id || '--',
  },
  {
    dataKey: 'created_at',

    name: 'Invoice Date',
    sortable: true,
    selector: (row) => (
      <PixelDate format={'pixelStandard'} value={row.created_at.date} />
    ),
  },
  {
    dataKey: 'invoice_period_start.date',

    name: 'Billing Period',
    sortable: true,
    selector: (row) => (
      <PixelFlexBox>
        <PixelText multiLine>
          <PixelDate
            format={'pixelStandard'}
            value={row?.invoice_period_start?.date}
          />
          -
          <PixelDate
            format={'pixelStandard'}
            value={row?.invoice_period_end?.date}
          />
        </PixelText>
      </PixelFlexBox>
    ),
  },
  {
    dataKey: 'billing_invoice_due_date.date',

    name: 'Due Date',
    sortable: true,
    selector: (row) =>
      (
        <PixelDate
          format={'pixelStandard'}
          value={row.billing_invoice_due_date.date}
        />
      ) || '--',
  },
  {
    dataKey: 'billing_invoice_total',
    name: 'Amount',
    sortable: true,
    selector: (row) => (
      <PixelCurrency value={row.billing_invoice_total} currency={'PKR'} />
    ),
  },
  {
    dataKey: 'billing_invoice_status',
    name: 'Status',
    sortable: true,
    selector: (row) => (
      <DcTag
        customBackgroundColor={
          row.billing_invoice_status === 'paid'
            ? $DCSuccessLightColor
            : row.billing_invoice_status === 'unpaid'
            ? $DCDangerLightColor
            : $DCInfoLightColor
        }
        textColor={
          row.billing_invoice_status === 'paid'
            ? $DCSuccessColor
            : row.billing_invoice_status === 'unpaid'
            ? $DCDangerColor
            : $DCInfoColor
        }
      >
        {row.billing_invoice_status}
      </DcTag>
    ),
  },
  {
    dataKey: 'billing_invoice_amount_received',
    name: 'Amount Paid',
    sortable: true,
    selector: (row) => row.billing_invoice_amount_received || '--',
  },
  {
    dataKey: 'actions',
    name: 'Print Invoice',
    selector: (row) => <PixelTableAction row={row} action={actions} />,
  },
]
const baseURL = env.SERVER_ADDR
const actions = [
  {
    title: 'Print Invoice',
    icon: (
      <>
        <Section>
          <PrintIcon size={18} />
        </Section>
      </>
    ),
    clickHandler: (d) => {
      const { token } = JSON.parse(
        localStorage.getItem('user_info') || '{token: null}',
      )
      window.open(`${baseURL}api/v2/print/billing/invoice/${token}/${d.id}`)
    },
  },
]
const breadcrumbs = [
  {
    name: 'Settings',
    active: false,
  },
  {
    name: 'Subscription Plans',
    active: true,
  },
]
const PlanBilling = () => {
  const { showLoader, hideLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const mainSectionRef = React.useRef(null)
  const [activePlan, setActivePlan] = React.useState<any>()
  const [tableLoading, setTableLoading] = React.useState(true)
  const [billingInvoices, setBillingInvoices] = React.useState([])

  React.useEffect(() => {
    fetchActivePlan()
    readData()
  }, [])

  const fetchActivePlan = () => {
    showLoader(mainSectionRef)
    get('/settings/subscription-plans/active').subscribe(
      (res: AjaxResponse<any>) => {
        setActivePlan(res?.response?.data)
        hideLoader(mainSectionRef)
      },
    )
  }
  const readData = () => {
    setTableLoading(true)
    get('/settings/billing/invoices').subscribe((res: AjaxResponse<any>) => {
      setBillingInvoices(res?.response?.data)
      setTableLoading(false)
    })
  }

  return (
    <>
      <PixelPageContainer style={{ padding: '0px', maxHeight: '100vh' }}>
        <Section style={{ padding: '0px' }}>
          <SectionContent style={{ padding: '0px', borderRadius: '0px' }}>
            <DcFlexBox
              height="60px"
              fontSize="16px"
              style={{
                fontSize: '16px',
                padding: '8px 0px',
              }}
            >
              <DcFlexBox
                justifyContent="space-between"
                alignItems="center"
                padding=".5rem 20px"
              >
                <DcBreadcrumbs fontSize="16px" data={breadcrumbs} />

                <ProfileSection />
              </DcFlexBox>
            </DcFlexBox>
          </SectionContent>
        </Section>
        <Section style={{ display: 'flex', padding: '0px' }}>
          <Section style={{ width: '30%', height: '100%', padding: '20px' }}>
            <BillingPaymentMethod />
          </Section>
          <Section style={{ width: '70%', height: '100%' }}>
            <Section
              style={{
                padding: isMobile ? '0' : '10px',
              }}
            >
              <SectionTitle>Active Plan</SectionTitle>
              <SectionContent
                style={{ display: 'flex', justifyContent: 'space-between' }}
                // flexDirection="row"
                // justifyContent="space-between"
                // backgroundColor="#ffffffd4"
                // margin="0 auto"
                // style={{
                //   boxShadow: ' 0px 2px 6px rgba(0, 0, 0, 0.25)',
                //   borderRadius: '12px',
                //   minHeight: '150px',
                //   width: isMobile ? '100%' : '100%',
                // }}
                // className="table-info-container"
                // ref={mainSectionRef}
              >
                <>
                  <PixelDiv padding="0 0 10px 0">
                    <PixelDiv
                      style={{
                        display: ' flex',
                        flexDirection: 'row',
                        alignItems: 'flex-end',
                        margin: '0 0 0 20px',
                      }}
                    >
                      <PixelText
                        customColor="#7b809a"
                        textSize="25px"
                        style={{
                          paddingLeft: '5px',
                          marginTop: '5px',
                          fontWeight: '700',
                        }}
                      >
                        {activePlan?.plan_name || 'None'}
                      </PixelText>
                      <PixelText
                        style={{
                          marginLeft: '12px',
                          background: 'rgb(209, 250, 229)',
                          color: 'rgb(45, 197, 140)',
                          borderRadius: '6px',
                          padding: '2px 10px',
                        }}
                      >
                        Active
                      </PixelText>
                    </PixelDiv>
                    <PixelFlexBox
                      flexDirection="column"
                      margin="10px 0 10px 20px"
                      height="auto"
                    >
                      <PixelText
                        customColor="#344767"
                        textSize="45px"
                        style={{ fontWeight: '700' }}
                      >
                        ${activePlan?.plan_base_price || '0'}
                      </PixelText>
                    </PixelFlexBox>
                    <PixelDiv
                      style={{
                        display: ' flex',
                        flexDirection: 'row',
                        alignItems: 'flex-end',
                        margin: '0 0 0 20px',
                      }}
                    >
                      <PixelText customColor="#50b153" textSize="18px">
                        {activePlan?.plan_orders_limit || '0'}
                      </PixelText>
                      <PixelText
                        textSize="16px"
                        customColor="#848aa2"
                        style={{ marginLeft: '5px' }}
                      >
                        Plan Order Limit
                      </PixelText>
                    </PixelDiv>
                    <PixelDiv
                      style={{
                        display: ' flex',
                        flexDirection: 'row',
                        alignItems: 'flex-end',
                        margin: '0 0 0 20px',
                      }}
                    >
                      <PixelText customColor="#50b153" textSize="18px">
                        {activePlan?.plan_additional_usage_price_per_order ||
                          '--'}
                      </PixelText>
                      <PixelText
                        textSize="16px"
                        customColor="#848aa2"
                        style={{ marginLeft: '5px' }}
                      >
                        Charges Per Transaction After Limit
                      </PixelText>
                    </PixelDiv>
                  </PixelDiv>
                  <PixelDiv
                    style={{
                      display: 'flex',
                      flexDirection: isMobile ? 'row' : 'column',
                      justifyContent: 'space-between',
                      margin: isMobile ? '0px' : '26px 20px 0px 0px',
                      padding: isMobile ? '10px' : '0 0 10px 0',
                    }}
                  >
                    {activePlan?.plan_start_date ? (
                      <PixelText customColor="#848aa2" textSize="22px">
                        {moment(activePlan?.plan_start_date).format('ll')}
                      </PixelText>
                    ) : (
                      ''
                    )}

                    <Link
                      style={{ textDecoration: 'none' }}
                      to="/admin/subscription-plans/change-plan"
                    >
                      <DcButton size={isMobile ? 'sm' : 'lg'}>
                        Change Plan
                      </DcButton>
                    </Link>
                  </PixelDiv>
                </>
              </SectionContent>
            </Section>
            <Section style={{ padding: '10px' }} isMobile={isMobile}>
              <SectionTitle>Billing Invoices</SectionTitle>
              <SectionContent isMobile={isMobile}>
                <PixelTable
                  progressPending={tableLoading}
                  columns={columns}
                  data={billingInvoices}
                  fixedHeader
                  fixedHeaderScrollHeight="46.5vh"
                />
              </SectionContent>
            </Section>
          </Section>
        </Section>
      </PixelPageContainer>
    </>
  )
}

export default PlanBilling
